import React from 'react';

function UserCircle(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M7.80425 9.85282C7.80425 7.53519 9.68306 5.65639 12.0007 5.65639C14.3183 5.65639 16.1971 7.53519 16.1971 9.85282C16.1971 12.1704 14.3183 14.0492 12.0007 14.0492C9.68306 14.0492 7.80425 12.1704 7.80425 9.85282ZM12.0007 6.90639C10.3734 6.90639 9.05425 8.22555 9.05425 9.85282C9.05425 11.4801 10.3734 12.7992 12.0007 12.7992C13.6279 12.7992 14.9471 11.4801 14.9471 9.85282C14.9471 8.22555 13.6279 6.90639 12.0007 6.90639Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.0007 16.1917C9.72598 16.1917 7.61584 17.3776 6.43313 19.3206C6.25365 19.6155 5.86914 19.709 5.57429 19.5295C5.27944 19.3501 5.1859 18.9656 5.36538 18.6707C6.77491 16.355 9.28974 14.9417 12.0007 14.9417C14.7116 14.9417 17.2264 16.355 18.636 18.6707C18.8155 18.9656 18.7219 19.3501 18.4271 19.5295C18.1322 19.709 17.7477 19.6155 17.5682 19.3206C16.3855 17.3776 14.2754 16.1917 12.0007 16.1917Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7.04532 3.41274C10.1117 1.64237 13.8897 1.64237 16.956 3.41274C20.0224 5.18312 21.9114 8.45492 21.9114 11.9957C21.9114 17.4692 17.4742 21.9064 12.0007 21.9064C6.52714 21.9064 2.08997 17.4692 2.08997 11.9957C2.08997 8.45492 3.97894 5.18312 7.04532 3.41274ZM16.331 4.49528C13.6514 2.94819 10.35 2.94819 7.67032 4.49528C4.99069 6.04236 3.33997 8.9015 3.33997 11.9957C3.33997 16.7789 7.2175 20.6564 12.0007 20.6564C16.7839 20.6564 20.6614 16.7789 20.6614 11.9957C20.6614 8.9015 19.0107 6.04236 16.331 4.49528Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default UserCircle;
